export default {
  // list
  'base_parse_supplier_excel_config.query.fieldLabel': 'fieldLabel',
  'base_parse_supplier_excel_config.query.fieldLabel.placeholder': 'Enter fieldLabel',
  'base_parse_supplier_excel_config.query.fieldProperty': 'fieldProperty',
  'base_parse_supplier_excel_config.query.fieldProperty.placeholder': 'Enter fieldProperty',
  'base_parse_supplier_excel_config.query.excelCellNo': 'excelCellNo',
  'base_parse_supplier_excel_config.query.excelCellNo.placeholder': 'Enter excelCellNo',
  'base_parse_supplier_excel_config.column.fieldLabel': 'fieldLabel',
  'base_parse_supplier_excel_config.column.fieldProperty': 'fieldProperty',
  'base_parse_supplier_excel_config.column.excelCellNo': 'excelCellNo',
  'base_parse_supplier_excel_config.column.existColumn': 'existColumn',
  'base_parse_supplier_excel_config.column.defaultValue': 'defaultValue',
  'base_parse_supplier_excel_config.column.sortNo': 'sortNo',
  'base_parse_supplier_excel_config.column.createBy': 'createBy',
  'base_parse_supplier_excel_config.column.updateBy': 'updateBy',
  'base_parse_supplier_excel_config.column.createTime': 'createTime',
  'base_parse_supplier_excel_config.column.updateTime': 'updateTime',
  'base_parse_supplier_excel_config.column.dataSource': 'dataSource',
  'base_parse_supplier_excel_config.column.remark': 'remark',
  'base_parse_supplier_excel_config.column.status': 'status',
  // edit
  'base_parse_supplier_excel_config.edit.title': 'Edit BaseParseSupplierExcelConfig',
  'base_parse_supplier_excel_config.add.title': 'Add BaseParseSupplierExcelConfig',
  'base_parse_supplier_excel_config.edit.success': 'Edit Successful',
  'base_parse_supplier_excel_config.add.success': 'Add Successful',
  'base_parse_supplier_excel_config.form.fieldLabel.required': 'fieldLabel cannot be null',
  'base_parse_supplier_excel_config.form.fieldProperty.required': 'fieldProperty cannot be null',
  'base_parse_supplier_excel_config.form.existColumn.required': 'existColumn cannot be null',
  'base_parse_supplier_excel_config.form.sortNo.required': 'sortNo cannot be null',
  'base_parse_supplier_excel_config.form.fieldLabel': 'fieldLabel',
  'base_parse_supplier_excel_config.form.fieldLabel.placeholder': 'Enter fieldLabel',
  'base_parse_supplier_excel_config.form.fieldProperty': 'fieldProperty',
  'base_parse_supplier_excel_config.form.fieldProperty.placeholder': 'Enter fieldProperty',
  'base_parse_supplier_excel_config.form.excelCellNo': 'excelCellNo',
  'base_parse_supplier_excel_config.form.excelCellNo.placeholder': 'Enter excelCellNo',
  'base_parse_supplier_excel_config.form.existColumn': 'existColumn',
  'base_parse_supplier_excel_config.form.existColumn.placeholder': 'Enter existColumn',
  'base_parse_supplier_excel_config.form.defaultValue': 'defaultValue',
  'base_parse_supplier_excel_config.form.defaultValue.placeholder': 'Enter defaultValue',
  'base_parse_supplier_excel_config.form.sortNo': 'sortNo',
  'base_parse_supplier_excel_config.form.sortNo.placeholder': 'Enter sortNo',
}
